export default __webpack_public_path__ + "static/media/ok.b621e694.png";